import React from 'react';
import HeroSection from './components/HeroSection.jsx';
import FeatureCards from './components/FeatureCards.jsx';
import TeamShowcase from './components/TeamShowcase.jsx';
import ImageGallery from './components/ImageGallery.jsx';
import TestimonialCards from './components/TestimonialCards.jsx';
import StatsCounter from './components/StatsCounter.jsx';
import BlogCards from './components/BlogCards.jsx';
import ContactSection from './components/ContactSection.jsx';

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <HeroSection />
      <FeatureCards />
      <TeamShowcase />
      <ImageGallery />
      <TestimonialCards />
      <StatsCounter />
      <BlogCards />
      <ContactSection />
    </div>
  );
}

export default App;